export const INQUIRY_QUESTION_DEFAULT_VALUE = 'Können wir diesem Patienten weiterhelfen?';
